module.exports = __webpack_public_path__ + "static/media/caret-up.f7a1cc5f.svg";